// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"35187009","131":"921a59e7","134":"8c5bc6ad"}[chunkId] + ".chunk.js";
};